import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { CACHE_KEY_PRESCRIPTION } from 'src/app/hooks/data/_keys';
import { useBffClient } from 'src/app/hooks/data/useBffClient';
import type { MedicationDetails } from 'src/app/types';

export const useMedicationDetails = (
  prescriptionId: number,
  enabled?: boolean
): UseQueryResult<MedicationDetails, AxiosError> => {
  const authClient = useBffClient();

  return useQuery(
    [CACHE_KEY_PRESCRIPTION, prescriptionId],
    () =>
      authClient
        .get(`/prescriptions/${prescriptionId}/drug_detail`)
        .then((resp: { data: MedicationDetails }) => resp.data),
    {
      ...(enabled !== undefined && { enabled }),
    }
  );
};
